import { render, staticRenderFns } from "./InfoPanelCustomData.vue?vue&type=template&id=8d1f8434&scoped=true&"
import script from "./InfoPanelCustomData.vue?vue&type=script&lang=js&"
export * from "./InfoPanelCustomData.vue?vue&type=script&lang=js&"
import style0 from "./InfoPanelCustomData.vue?vue&type=style&index=0&id=8d1f8434&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1f8434",
  null
  
)

export default component.exports